(function () {
  var MB_HOST = "https://multibuy-tierfutterpro.vercel.app"; // beim Kopieren für neuen Shop anpassen

  function fmt(n) {
    return n.toFixed(2).replace(".", ",") + " €";
  }

  function renderPrices(widget) {
    var price = parseFloat(widget.dataset.price);
    widget.querySelectorAll(".mb-tile").forEach(function (tile) {
      var qty = parseInt(tile.dataset.qty, 10);
      var type = tile.dataset.type;
      var value = parseFloat(tile.dataset.value) || 0;
      var cents = Math.round(price * 100);
      var full = (cents * qty) / 100;
      // Wie Shopify: Prozent-Rabatt pro Stück, auf Cent ABgerundet
      var final =
        type === "percent" ? ((cents - Math.floor((cents * value) / 100)) * qty) / 100
        : type === "amount" ? Math.max(0, full - value)
        : full;
      var savedEuro = (full - final).toFixed(2).replace(".", ",");
      var mode = widget.dataset.saveDisplay || "percent";
      var save = "";
      if (type === "amount") {
        save = widget.dataset.saveAmt.replace("{amt}", savedEuro);
      } else if (type === "percent") {
        var pctText = widget.dataset.savePct.replace("{pct}", value);
        save =
          mode === "amount" ? widget.dataset.saveAmt.replace("{amt}", savedEuro)
          : mode === "both" ? pctText + " (" + savedEuro + " €)"
          : pctText;
      }
      tile.querySelector(".mb-price").innerHTML =
        (type !== "none" ? "<s>" + fmt(full) + "</s>" : "") +
        "<b>" + fmt(final) + "</b>" +
        (save ? '<span class="mb-save">' + save + "</span>" : "");
      // Stückzahl-Badge (Template aus Config, Standard "{qty} Stk.")
      var qtyBadge = tile.querySelector(".mb-qtybadge");
      if (qtyBadge) {
        var qtyTpl = widget.dataset.qtyText || "{qty} Stk.";
        qtyBadge.textContent = qtyTpl.replace("{qty}", qty);
      }
      // Grundpreis (falls Produkt einen hat): auf Basis des rabattierten Preises
      var unitEl = tile.querySelector(".mb-unit");
      var unitBase = parseFloat(widget.dataset.unitBase);
      if (unitEl && unitBase && price > 0) {
        var unitNow = (final / qty) * (unitBase / price);
        unitEl.textContent = fmt(unitNow) + " / " + widget.dataset.unitLabel;
      } else if (unitEl) {
        unitEl.textContent = ""; // Variante ohne Grundpreis: alten Wert nicht stehen lassen
      }
    });
  }

  function selectedTile(widget) {
    return widget.querySelector(".mb-tile.mb-selected") || widget.querySelector(".mb-tile");
  }

  // cart/update.js ERSETZT die komplette Code-Liste des Warenkorbs. Wird nur der neue
  // Code gesendet, verliert der zuvor per Widget gekaufte Artikel seinen Rabatt ("der
  // Code springt zum zuletzt hinzugefügten Artikel"). Deshalb die vorhandenen Codes
  // mitschicken — die API akzeptiert sie kommagetrennt.
  // Nicht anwendbare Codes (abgelaufen/verbraucht) fallen dabei raus; fehlt das Feld
  // `applicable`, wird der Code behalten (nur bei explizitem false verwerfen).
  function mergeCodes(cart, code) {
    var kept = (cart.discount_codes || [])
      .filter(function (d) { return d.applicable !== false && d.code !== code; })
      .map(function (d) { return d.code; });
    return kept.concat(code).join(",");
  }

  function setBusy(form, busy) {
    var btn = form.querySelector('[type="submit"], button[name="add"]');
    if (!btn) return;
    btn.setAttribute("aria-busy", busy ? "true" : "false");
    btn.classList.toggle("is-loading", busy); // Theme-Spinner (.svg-loader via theme.min.css)
  }

  // Sizecards-Select (name="id") hängt per form-Attribut AUSSERHALB des Forms.
  // ACHTUNG: form.id ist hier durch den Input name="id" GESHADOWT (liefert das
  // Element statt der ID) — deshalb immer form.getAttribute("id") verwenden!
  function variantInput(form) {
    var fid = form.getAttribute("id");
    return (
      document.querySelector('[name="id"][form="' + fid + '"]:not([disabled])') ||
      form.querySelector('[name="id"]:not([disabled])') ||
      form.querySelector('[name="id"]')
    );
  }

  async function buy(widget, form) {
    if (widget.dataset.mbBusy === "1") return; // Doppelklick-Schutz
    widget.dataset.mbBusy = "1";
    setBusy(form, true); // sofortiges Feedback: Spinner an, Button gesperrt
    try {
      var tile = selectedTile(widget);
      var qty = parseInt(tile.dataset.qty, 10);
      var type = tile.dataset.type;
      var variantId = variantInput(form).value;

      // Code-Erzeugung und Warenkorb-Add laufen PARALLEL
      var codePromise = Promise.resolve(null);
      if (type !== "none") {
        codePromise = fetch(MB_HOST + "/api/code", {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({ dealId: widget.dataset.dealId, qty: qty, variantId: Number(variantId), productId: Number(widget.dataset.productId) }),
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) { return j && j.code; })
          .catch(function () { return null; }); // Fallback: ohne Code fortfahren
      }
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] }),
      });

      // Drawer SOFORT öffnen (Theme-Stil, Setup wie der .Sd_addProduct-Handler in
      // cart-ajax.js) — die Code-Anwendung läuft danach im Hintergrund weiter
      var cart = await fetch(window.Shopify.routes.root + "cart.js").then(function (r) { return r.json(); });
      var $ = window.jQuery;
      if (!$ || typeof window.buildCart !== "function") {
        var code0 = await codePromise;
        if (code0) {
          await fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({ discount: mergeCodes(cart, code0) }),
          }).catch(function () {});
        }
        window.location.href = window.Shopify.routes.root + "cart";
        return;
      }
      if (typeof preLoadLoadGif !== "undefined") $("[data-drawer-body]").html(preLoadLoadGif);
      $("[data-side-drawer]").attr("class", "yv_side_drawer_wrapper");
      if (typeof cartTitleLabel !== "undefined") $("[data-drawer-title]").html(cartTitleLabel);
      $("[data-side-drawer]").attr("id", "mini__cart").addClass("mini_cart");
      $("body").removeClass("quickview-open").addClass("side_Drawer_open");
      window.buildCart(cart, true);
      setBusy(form, false);

      // Frische Codes brauchen ~2s Shopify-Propagation: anwenden, prüfen, ggf. wiederholen.
      // Abbruch, sobald der NEUE Code greift — als Rabatt-Vergleich dient der Stand
      // direkt nach dem Add (enthält schon die Codes früherer Widget-Käufe), nicht die
      // Frage "liegt überhaupt ein Rabatt im Warenkorb".
      var code = await codePromise;
      if (code) {
        var baseDiscount = cart.total_discount || 0;
        for (var attempt = 0; attempt < 5; attempt++) {
          var upd = await fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({ discount: mergeCodes(cart, code) }),
          }).then(function (r) { return r.json(); }).catch(function () { return {}; });
          var applied = (upd.discount_codes || []).some(function (d) {
            return d.code === code && d.applicable;
          });
          if (applied) break;
          if ((upd.total_discount || 0) > baseDiscount) break;
          await new Promise(function (r) { setTimeout(r, 700); });
        }
        // Drawer-Inhalt nachziehen, falls sich die Summe durch den Code geändert hat
        var cart2 = await fetch(window.Shopify.routes.root + "cart.js").then(function (r) { return r.json(); });
        if (cart2.total_price !== cart.total_price || cart2.total_discount !== cart.total_discount) {
          window.buildCart(cart2, false);
        }
      }
    } finally {
      setBusy(form, false);
      widget.dataset.mbBusy = "";
    }
  }

  document.querySelectorAll(".mb-widget").forEach(function (widget) {
    if (widget.dataset.mbInit) return;
    widget.dataset.mbInit = "1";
    renderPrices(widget);

    widget.querySelectorAll(".mb-tile").forEach(function (tile) {
      tile.addEventListener("click", function () {
        widget.querySelectorAll(".mb-tile").forEach(function (t) { t.classList.remove("mb-selected"); });
        tile.classList.add("mb-selected");
      });
    });

    var form = document.getElementById(widget.dataset.formId);
    if (!form) return;

    // Anzahl-Selector ausblenden — die Kacheln übernehmen die Mengenwahl
    var qtyInput = document.querySelector('input[name="quantity"][form="' + widget.dataset.formId + '"]');
    var qtyWrap = qtyInput && qtyInput.closest("[data-product-quantity-wrapper]");
    if (qtyWrap) qtyWrap.style.display = "none";
    // .product_button hat flex-basis 0 (per !important) und kollabiert (v. a. mobil)
    // ohne den Selector als Zeilen-Nachbarn auf 0px — volle Flex-Zeile erzwingen
    var pb = widget.closest(".product_button");
    if (pb) pb.style.setProperty("flex", "1 1 100%", "important");

    // Das Theme fängt Klicks auf .Sd_addProduct per jQuery (Bubble-Phase auf body) ab
    // und macht ein eigenes AJAX-Add — ein Form-submit-Event feuert nie. Deshalb den
    // Klick in der CAPTURE-Phase abgreifen und die Propagation stoppen.
    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest(".Sd_addProduct");
      if (!btn) return;
      var btnForm = btn.closest("form") || document.getElementById(btn.getAttribute("form"));
      if (btnForm !== form) return;
      var tile = selectedTile(widget);
      if (parseInt(tile.dataset.qty, 10) <= 1) return; // Standardverhalten des Themes
      e.preventDefault();
      e.stopPropagation();
      buy(widget, form);
    }, true);

    // Fallback (z. B. Enter-Taste): echtes Submit ebenfalls abfangen
    form.addEventListener("submit", function (e) {
      var tile = selectedTile(widget);
      if (parseInt(tile.dataset.qty, 10) <= 1) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      buy(widget, form);
    }, true);

    // Preis/Grundpreis aus der Liquid-Varianten-Map (data-variants) übernehmen —
    // deckt auch den Grundpreis-Fallback für Varianten ohne unit_price ab
    var variants = {};
    try { variants = JSON.parse(widget.dataset.variants || "{}"); } catch (err) {}
    function syncFromVariant() {
      var input = variantInput(form);
      var v = input && variants[input.value];
      if (!v) return;
      widget.dataset.price = v.p;
      if (v.ub) { widget.dataset.unitBase = v.ub; widget.dataset.unitLabel = v.ul; }
      else { delete widget.dataset.unitBase; }
      renderPrices(widget);
    }
    syncFromVariant(); // Startzustand (z. B. per ?variant= vorausgewählte Größe)
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (!form.contains(t) && (!t.getAttribute || t.getAttribute("form") !== widget.dataset.formId)) return;
      syncFromVariant();
    });
  });
})();
